import sha256 from 'crypto-js/sha256';

/* =========================================================================
Funcion/Procedimiento:   encrypt
Description :   funcion de encriptacion vibeconsulting validando ascii de la
                cadena ingresada:
Parameters  :   cadena String de la cadena a encriptar:
Return      :   string encriptado.
Date         Autor              Modification
============================================================================
XX/XX/XXXX   Santiago             Creacion
=========================================================================*/
function encrypt(cadena){
    const arr = cadena.split("");
    let desencrypted = "";
    arr.forEach(element => {
        let ascii = element.charCodeAt(0);
        let esPar = ((ascii % 2 ) + 2 ) % 2
        if(esPar == 0){
            ascii += 4;
        }
        else{
            ascii += 2;
        }
        let charReal = String.fromCharCode(ascii);
        desencrypted += charReal;
    });
    return desencrypted;
}
/* =========================================================================
Funcion/Procedimiento:   GetTokenCreateUser
Description :   funcion de generacion del token de creación de usuarios de 
                remuenr lite:
Parameters  :   user   String con el usuario el cual debe presenta longitud 12, 
                pass   String con el password plano del usuario, 
                time   String Hora y minutos (formato militar hhmm) con longitud 4, 
                date   String de fecha en formato (yyyyddmm) con longitud 8
Return      :   cadena encriptada que se usara como token
Date         Autor              Modification
============================================================================
16/02/2022   cmejia             Creacion
=========================================================================*/
export const GetTokenCreateUser = (user, pass, time, date)=>{
    //Se valida que el usuario tenga esta longitud de 12 caracteres:
    if (user.length == 12 && time.length == 4 && date.length == 8) {
        let passRemuner     = user.toUpperCase()+pass;
        passRemuner         = sha256(passRemuner).toString();
        let cipherHourMin   = encrypt(time); 
        let cipherUser      = encrypt(user);
        let cipherDate      = encrypt(date); 
        let cipherToken     = cipherHourMin+cipherUser+passRemuner+cipherDate;
        return cipherToken;
    }
    else{
        return 'Error: Los parámetros no cumplen los criterios.';
    }
};